import {
	getAdminWidgetTenantIdFromQueryParams,
	getBaseUrl,
	getProjectId
} from '../utils';
import { AuditManagement, AuthProvider } from '@descope/react-sdk';

const AuditManagementWidget = () => {
	return (
		<AuthProvider projectId={getProjectId()} baseUrl={getBaseUrl()}>
			<div
				style={{
					height: '100vh',
					position: 'relative',
					padding: '2em',
					backgroundImage:
						'linear-gradient(rgb(79,180,184), rgb(195, 143, 135))'
				}}
			>
				<AuditManagement
					widgetId="audit-management-widget"
					tenant={getAdminWidgetTenantIdFromQueryParams()}
				/>
			</div>
		</AuthProvider>
	);
};

export default AuditManagementWidget;
